import { Configuration } from '../configuration/configuration';
import { PathRoutes } from '../configuration/pathRoutes';
import { LicenseCheckerService } from '../helper/licenseChecker';
import { SessionHelper } from '../helper/sessionHelper';

export interface MenuItem {
  path: string;
  title: string;
  sortTitle: string;
  icon: string;
  class: string;
  roles?: string[];
  isParent: boolean;
  childs: MenuItem[];
  allowNew: boolean;
}

const checker = new LicenseCheckerService();
const session = new SessionHelper();


const buildMenuItems = (): MenuItem[] => {
  const hasHostelHR = checker.checkLicense("hostelHR");
  const hasLivesHR = checker.checkLicense("livesHR");
  const hasAttendance = checker.checkLicense("attendance");
  const hasConectia = checker.checkLicense("conectia");

  return [
    {
      path: PathRoutes.welcome,
      title: 'Bienvenida',
      sortTitle: 'TD',
      icon: 'home',
      class: 'nav-item',
      isParent: true,
      allowNew: false,
      roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
      childs: [],
    },
    {
      path: PathRoutes.app,
      title: 'Portal del Empleado',
      sortTitle: 'APP',
      icon: 'mobile-alt',
      class: 'nav-item',
      isParent: true,
      allowNew: false,
      roles: [Configuration.rolAdministrador, Configuration.rolUsuario],
      childs: [
        ...(hasLivesHR
          ? [{
            path: PathRoutes.appReqs,
            roles: [Configuration.rolUsuario],
            title: 'Solicitudes',
            sortTitle: 'RE',
            icon: '',
            class: 'nav-item',
            isParent: false,
            allowNew: false,
            childs: [
              {
                path: PathRoutes.appRequests,
                roles: [Configuration.rolUsuario],
                title: 'Solicitudes',
                sortTitle: 'REQ',
                icon: 'calendar-check',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: false
              },
              {
                path: PathRoutes.appRequests,
                roles: [Configuration.rolUsuario],
                title: 'Calendario',
                sortTitle: 'CAL',
                icon: 'calendar-day',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: false
              }
            ],
          }]
          : [])
        ,
        ...(hasAttendance
          ? [{
            path: PathRoutes.appClocking,
            roles: [Configuration.rolUsuario],
            title: 'Control horario',
            sortTitle: 'CO',
            icon: '',
            class: 'nav-item',
            isParent: false,
            allowNew: false,
            childs: [
              {
                path: PathRoutes.appClockingConfig,
                roles: [Configuration.rolUsuario],
                title: 'Configuración Marcajes',
                sortTitle: 'CFGM',
                icon: 'business-time',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: false
              },
              {
                path: PathRoutes.appClockings,
                roles: [Configuration.rolUsuario],
                title: 'Marcajes',
                sortTitle: 'CFGM',
                icon: 'user-clock',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: false
              }
            ],
          }]
          : [])
        ,
        ...(hasLivesHR
          ? [{
            path: PathRoutes.appDocuments,
            roles: [Configuration.rolUsuario],
            title: 'Comunicación',
            sortTitle: 'COM',
            icon: '',
            class: 'nav-item',
            isParent: false,
            allowNew: false,
            childs: [
              {
                path: PathRoutes.appDocs,
                roles: [Configuration.rolUsuario],
                title: 'Documentos',
                sortTitle: 'DOC',
                icon: 'file-alt',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: true
              },
              {
                path: PathRoutes.appOnboarding,
                roles: [Configuration.rolUsuario],
                title: 'Onboarding',
                sortTitle: 'ONB',
                icon: 'door-open',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: false
              },
              {
                path: PathRoutes.appBulletinBoard,
                roles: [Configuration.rolUsuario],
                title: 'Anuncios',
                sortTitle: 'ANU',
                icon: 'newspaper',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: false
              },
              {
                path: PathRoutes.appChat,
                roles: [Configuration.rolUsuario],
                title: 'Chat',
                sortTitle: 'CHAT',
                icon: 'comments',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: false
              }
            ],
          }]
          : [])
        ,
        {
          path: PathRoutes.appConfig,
          roles: [Configuration.rolAdministrador, Configuration.rolUsuario],
          title: 'Configuración',
          sortTitle: 'CFA',
          icon: '',
          class: 'nav-item',
          isParent: true,
          allowNew: false,
          childs: [
            ...(hasLivesHR
              ? [{
                path: PathRoutes.appEnvConfig,
                roles: [Configuration.rolAdministrador],
                title: 'Parametrización del Entorno',
                sortTitle: 'CFE',
                icon: 'cog',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: false
              }]
              : [])
            ,
            {
              path: PathRoutes.appCompanies,
              roles: [Configuration.rolAdministrador, Configuration.rolUsuario],
              title: 'Empresas',
              sortTitle: 'EM',
              icon: 'building',
              class: 'nav-item',
              isParent: false,
              childs: null,
              allowNew: session.User?.Roles?.includes(Configuration.rolAdministrador) || false
            },
            {
              path: PathRoutes.appUsers,
              roles: [Configuration.rolAdministrador, Configuration.rolUsuario],
              title: 'Empleados',
              sortTitle: 'AU',
              icon: 'user-cog',
              class: 'nav-item',
              isParent: false,
              childs: null,
              allowNew: false
            }
          ],
        },
      ],
    },
    {
      path: PathRoutes.employee,
      title: 'Hostelería',
      sortTitle: 'TR',
      icon: 'hotel',
      class: 'nav-item',
      roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
      isParent: true,
      allowNew: false,
      childs: [
        {
          path: PathRoutes.holidays,
          title: 'Gestión de Bolsa y Vacaciones',
          sortTitle: 'TR',
          icon: 'calendar',
          class: 'nav-item',
          roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
          isParent: false,
          allowNew: false,
          childs: [
            {
              path: PathRoutes.asignarTipoCalculoEmpleado,
              title: 'Asignación tipo cálculo',
              sortTitle: 'TR',
              icon: 'user-tag',
              class: 'nav-item',
              roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
              isParent: false,
              allowNew: false,
              childs: [],
            },
            {
              path: PathRoutes.bolsa,
              title: 'Bolsa Vacaciones',
              sortTitle: 'TR',
              icon: 'wallet',
              class: 'nav-item',
              roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
              isParent: false,
              allowNew: true,
              childs: [],
            },
            {
              path: PathRoutes.liquidaciones,
              title: 'Liquidaciones de Bolsa',
              sortTitle: 'TR',
              icon: 'file-invoice-dollar',
              class: 'nav-item',
              roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
              isParent: false,
              allowNew: false,
              childs: [],
            },
            {
              path: PathRoutes.periodos,
              title: 'Vacaciones',
              sortTitle: 'TR',
              icon: 'calendar-alt',
              class: 'nav-item',
              roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
              isParent: false,
              allowNew: false,
              childs: [],
            },
          ],
        },
        {
          path: PathRoutes.gestionEmpleados,
          title: 'Gestión de empleados',
          sortTitle: 'GE',
          icon: 'users',
          class: 'nav-item',
          roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
          isParent: false,
          allowNew: false,
          childs: [
            {
              path: PathRoutes.empleados,
              title: 'Empleados',
              sortTitle: 'EM',
              icon: 'users',
              class: 'nav-item',
              roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
              isParent: false,
              allowNew: true,
              childs: [],
            },
            {
              path: PathRoutes.tramosCodigoEmpleados,
              title: 'Tramos Código Empleados',
              sortTitle: 'CD',
              icon: 'sliders-h',
              class: 'nav-item',
              roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
              isParent: false,
              allowNew: false,
              childs: [],
            },
          ],
        },
        {
          path: PathRoutes.its,
          title: 'Gestión de sustituciones',
          sortTitle: 'IT',
          icon: 'calendar',
          class: 'nav-item',
          roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
          isParent: false,
          allowNew: false,
          childs: [
            {
              path: PathRoutes.substitution,
              title: 'Sustituciones',
              sortTitle: 'TR',
              icon: 'people-arrows',
              class: 'nav-item',
              roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
              isParent: false,
              allowNew: true,
              childs: [],
            },
          ],
        },
        {
          path: PathRoutes.reports,
          title: 'Informes',
          sortTitle: 'IT',
          icon: 'scroll',
          class: 'nav-item',
          roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
          isParent: false,
          allowNew: false,
          childs: [
            {
              path: PathRoutes.requestedDays,
              title: 'Días solicitados',
              sortTitle: 'TR',
              icon: 'scroll',
              class: 'nav-item',
              roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
              isParent: false,
              allowNew: false,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      path: PathRoutes.appIncidents,
      title: 'myReport!n',
      sortTitle: 'DEN',
      icon: 'vial',
      class: 'nav-item',
      isParent: true,
      allowNew: false,
      roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
      childs: [],
    },
    {
      path: PathRoutes.appKlikTicket,
      title: 'KlikTicket',
      sortTitle: 'KTK',
      icon: 'vest',
      class: 'nav-item',
      isParent: true,
      allowNew: false,
      roles: [Configuration.rolUsuario, Configuration.rolAdministrador],
      childs: [],

    },
    {
      path: PathRoutes.config,
      title: 'Configuración',
      sortTitle: 'CF',
      icon: 'cogs',
      class: 'nav-item',
      roles: [Configuration.rolAdministrador],
      isParent: true,
      allowNew: false,
      childs: [
        {
          path: PathRoutes.myAccount,
          roles: [Configuration.rolAdministrador],
          title: 'Mi cuenta',
          sortTitle: 'E',
          icon: '',
          class: 'nav-item',
          isParent: false,
          allowNew: false,
          childs: [
            {
              path: PathRoutes.myUsers,
              roles: [Configuration.rolAdministrador],
              title: 'Usuarios',
              sortTitle: 'US',
              icon: 'users-cog',
              class: 'nav-item',
              isParent: false,
              childs: null,
              allowNew: false,
            },
            ...(hasHostelHR
              ? [{
                path: PathRoutes.myConfig,
                roles: [Configuration.rolAdministrador],
                title: 'Configuración empresas',
                sortTitle: 'US',
                icon: 'cog',
                class: 'nav-item',
                isParent: false,
                childs: null,
                allowNew: true
              }]
              : [])
          ]
        },
        ...(hasHostelHR || hasConectia || hasLivesHR
          ? [{
            path: PathRoutes.admin,
            roles: [Configuration.rolAdministrador],
            title: 'Administración',
            sortTitle: 'E',
            icon: '',
            class: 'nav-item',
            isParent: false,
            allowNew: false,
            childs: [
              ...(hasHostelHR
                ? [{
                  path: PathRoutes.myProcess,
                  roles: [Configuration.rolAdministrador],
                  title: 'Procesos',
                  sortTitle: 'US',
                  icon: 'server',
                  class: 'nav-item',
                  isParent: false,
                  childs: null,
                  allowNew: false
                }]
                : [])
              ,
              ...(hasConectia
                ? [{
                  path: PathRoutes.conectia,
                  roles: [Configuration.rolAdministrador],
                  title: 'Conexión Conectia',
                  sortTitle: 'A3',
                  icon: 'server',
                  class: 'nav-item',
                  isParent: false,
                  childs: null,
                  allowNew: false
                }]
                : [])
              ,
              ...(hasLivesHR
                ? [{
                  path: PathRoutes.a3Doc,
                  roles: [Configuration.rolAdministrador],
                  title: 'Conexión A3Doc Cloud',
                  sortTitle: 'A3Doc',
                  icon: 'server',
                  class: 'nav-item',
                  isParent: false,
                  childs: null,
                  allowNew: false
                }]
                : [])
            ]
          }]
          : [])
      ]
    }
  ];

};

export const MenuItems: MenuItem[] = buildMenuItems();